var divider_viewer_default = {
  "divider-container": "X3Mfb",
  "divider-container--double": "_0SsG7",
  "divider": "uNESi",
  "divider--single": "bOOMG",
  "divider--double": "phJWK",
  "divider--dashed": "-cjlu",
  "divider--dotted": "DqyoS",
  "divider--small": "rqahz",
  "divider--medium": "Zl6vl",
  "divider--large": "v8vXN",
  "divider--left": "vFqKh",
  "divider--center": "snq8i",
  "divider--right": "y-Wp6",
  "svgFixerContainer": "Z-VT2",
  "emptyChar": "a8CWQ"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
